import { useState } from 'react'

import BalticLogo from '@/components/icons/BalticLogo'

// Mantine
import { Button, Anchor } from '@mantine/core'

import AuthenticationForm from '../components/guest/AuthenticationForm'
import AuthenticationFormOTP from '@/components/guest/AuthenticationFormOTP'
import QuickLogin from '@/components/guest/QuickLogin'
import PasskeyLogin from '@/components/guest/PasskeyLogin'
import Box from '@/components/ui/Box'

import DocumentTitle from '@/components/ui/DocumentTitle'

// Translations
import { useTranslation } from 'react-i18next'
import LocaleSelect from '@/components/ui/LocaleSelect'

import { motion } from 'motion/react'

// SWR
import useSWR from 'swr'

import { BACKOFFICE_API_URL } from '@/lib/constants'

const fetcher = (url) =>
    fetch(url, { credentials: 'include' }).then((res) => res.json())

const LoginPage = () => {
    const { t } = useTranslation()

    const [mode, setMode] = useState('login')

    // Quick login profiles from Cloudflare cert
    const { data, isLoading: isLoadingProfiles } = useSWR(
        BACKOFFICE_API_URL + '/quick-login/profiles',
        fetcher
    )

    const profiles = data?.profiles
    const hasQuickLogin = profiles && profiles.length > 0
    const [showQuickLogin, setShowQuickLogin] = useState(true)

    return (
        <div className="min-h-dvh flex flex-col items-center bg-white p-2">
            <DocumentTitle title="BO - Connexion" />

            <div className="flex flex-col gap-10 w-full max-w-[500px] mt-[100px]">
                <div className="mx-auto h-full flex items-center gap-3">
                    <BalticLogo className="w-[120px] text-gray-900" />
                </div>

                {!isLoadingProfiles && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="flex flex-col gap-10"
                    >
                        {mode === 'login' &&
                            (!showQuickLogin || !hasQuickLogin) && (
                                <Box className="">
                                    <AuthenticationForm />

                                    <div className="mx-auto mt-3">
                                        <Anchor
                                            size="sm"
                                            component="button"
                                            onClick={() => setMode('login_otp')}
                                        >
                                            {t('label_forgot')}
                                        </Anchor>
                                    </div>
                                </Box>
                            )}

                        {mode === 'login_otp' && (
                            <AuthenticationFormOTP
                                onBack={() => setMode('login')}
                            />
                        )}

                        {mode === 'login' &&
                            showQuickLogin &&
                            hasQuickLogin && <QuickLogin profiles={profiles} />}

                        {mode === 'login' && (
                            <div className="flex flex-col gap-3">
                                {hasQuickLogin && !showQuickLogin && (
                                    <Button
                                        onClick={() =>
                                            setShowQuickLogin(!showQuickLogin)
                                        }
                                        variant="default"
                                    >
                                        Afficher la connexion rapide
                                    </Button>
                                )}

                                {hasQuickLogin && showQuickLogin && (
                                    <div className="mx-auto">
                                        <Anchor
                                            component="button"
                                            onClick={() =>
                                                setShowQuickLogin(!showQuickLogin)
                                            }
                                            variant="default"
                                        >
                                            ← Retour à la connexion classique
                                        </Anchor>
                                    </div>
                                )}

                                <PasskeyLogin />
                            </div>
                        )}
                    </motion.div>
                )}
            </div>

            <div className="mt-auto w-full max-w-[500px] py-6">
                <LocaleSelect label="Language / Langue" />
            </div>
        </div>
    )
}

export default LoginPage
